module.exports = __webpack_public_path__ + "static/media/GPG600A_B01_SY.d9272339.jpg";